import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  public formResultsRef: firebase.database.Reference;

  constructor(private db: AngularFireDatabase) {
    this.formResultsRef = db.database.ref('/formResults');
  }

  saveFormResults(formResults, formName, user, currentDate) {
    return this.formResultsRef.child(`${formName}/${user}/${currentDate}`).set(formResults);
  }
}
